import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import DashboardWrapper from '../pages/dashboard/DashboardWrapper'
import OtpCode from "../modules/auth/components/Otp-code/Otp-code";

const PrivateRoutes = () => {

  return (
    <Routes>
      <Route element={<MasterLayout />}>
      </Route>
    </Routes>
  )
}

export {PrivateRoutes}
